import React from 'react'
import ReactDOM from 'react-dom'

type ReactPortalProps = {
  elementId: string
  enabled?: boolean
  children: React.ReactNode
}

export const ReactPortal = (props: ReactPortalProps) => {
  const {elementId, children, enabled = true} = props
  if (!enabled) {
    return <>{children}</>
  }

  const el = document.getElementById(elementId)
  return ReactDOM.createPortal(<>{children}</>, el)
}
